import { METHOD } from './method'

export const API_PRODUCT = {
    LIST: {
        api: '/v1/dashboard-admin/product/list',
        method: METHOD.POST,
    },
    BRAND_LIST: {
        api: '/v1/dashboard-admin/product/brands',
        method: METHOD.GET,
    },
    TYPE_LIST: {
        api: '/v1/dashboard-admin/product/types',
        method: METHOD.GET,
    },
    CATEGORY_LIST: {
        api: '/v1/dashboard-admin/product/categories',
        method: METHOD.GET,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/product/list/export',
        method: METHOD.POST,
    },
    BULK_ACTION: {
        api: '/v1/dashboard-admin/product/bulk-action',
        method: METHOD.POST,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/product',
        method: METHOD.GET,
    },
    URL_PRODUCT_IMAGES: {
        api: '/v1/dashboard-admin/product/storage-url/attachment',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/dashboard-admin/product',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/product',
        method: METHOD.PUT,
    },
    DRAFT: {
        api: '/v1/dashboard-admin/product/draft',
        method: METHOD.PUT,
    },
}
